module.exports = __webpack_public_path__ + "img/icon_storage_white.3879d864.svg";